import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = { class: "fs-regular" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_check = _resolveComponent("icon-check")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["io-shop-checkbox", {'invalid': _ctx.hasError}])
  }, [
    _createElementVNode("label", null, [
      _createElementVNode("div", null, [
        _createElementVNode("input", {
          type: "checkbox",
          checked: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args)))
        }, null, 40, _hoisted_1),
        _createElementVNode("span", null, [
          _createVNode(_component_icon_check)
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default"),
        (_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "io-shop-input--message fs-small",
              innerHTML: _ctx.errorMessage
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}